import * as React from 'react';
import { SVGProps } from 'react';
const MultiStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="9"
    height="12"
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.00001 3.48955C2.00001 3.64399 2.08335 3.78175 2.21668 3.85688L4.10417 4.89208L5.13753 6.78294C5.20835 6.91652 5.35003 7.00001 5.50003 7.00001C5.65419 7.00001 5.7917 6.91652 5.86669 6.78294L6.90002 4.89208L8.78337 3.85688C8.92087 3.78175 9.00002 3.64399 9.00002 3.48955C9.00002 3.33929 8.92087 3.19739 8.78337 3.12641L6.90002 2.09123L5.86669 0.200343C5.72085 -0.0667811 5.27918 -0.0667811 5.13753 0.200343L4.10417 2.09123L2.21668 3.12641C2.08335 3.19739 2.00001 3.33929 2.00001 3.48955Z"
      fill="#1A5072"
    />
    <path
      d="M4.19617e-05 9.49003C4.19617e-05 9.63862 0.0801105 9.77114 0.208193 9.84345L1.4612 10.5302L2.14576 11.7912C2.21781 11.9197 2.35393 12.0001 2.49804 12.0001C2.64616 12.0001 2.77827 11.9197 2.85033 11.7912L3.53488 10.5302L4.79187 9.84345C4.91998 9.77114 5.00005 9.63862 5.00005 9.49003C5.00005 9.34543 4.91998 9.2089 4.79187 9.14064L3.53488 8.44986L2.85033 7.19284C2.7102 6.9358 2.28586 6.9358 2.14576 7.19284L1.4612 8.44986L0.208193 9.14064C0.0801105 9.2089 4.19617e-05 9.34543 4.19617e-05 9.49003Z"
      fill="#186088"
    />
  </svg>
);
export default MultiStar;
